<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import BankingTransactionsWorkspace from '@/views/Banking/Transactions/BankingTransactionsWorkspace.vue'

setPageTitle(PageMeta.Banking.Transactions.Title)
definePage({ meta: PageMeta.Banking.Transactions.Meta })
</script>

<template>
  <BankingTransactionsWorkspace />
</template>
